import { useCallback, useEffect, useState } from "react";
import { listRecentHistory, subscribeToGlobalActivity, undoChange, type ChangeLogWithAuthor } from "./authoringRepository";

export function GlobalActivityPanel({ onClose }: { onClose: () => void }) {
  const [history, setHistory] = useState<ChangeLogWithAuthor[]>([]);
  const [error, setError] = useState<string>();
  const refresh = useCallback(async () => {
    try {
      setHistory(await listRecentHistory());
      setError(undefined);
    } catch (reason) { setError(reason instanceof Error ? reason.message : String(reason)); }
  }, []);
  useEffect(() => { void refresh(); return subscribeToGlobalActivity(() => void refresh()); }, [refresh]);

  return <aside className="global-activity" aria-label="Global authoring history"><header><strong>History</strong><button aria-label="Close activity" onClick={onClose}>×</button></header>{error && <p className="access-error">{error}</p>}<div className="activity-list">
    {history.map((change) => <article key={change.id}><strong>{change.table_name}.{change.field}</strong><span>{JSON.stringify(change.old_value)} → {JSON.stringify(change.new_value)}</span><small><i style={{ background: change.author?.editor_colour }} />{change.author?.display_name ?? change.user_id} · {new Date(change.created_at).toLocaleString()}</small><button onClick={() => void undoChange(change.id).then(refresh)}>Undo safely</button></article>)}
  </div></aside>;
}
